// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0bb5fe25","497":"21ef4865","780":"707c80c2"}[chunkId] + ".chunk.js";
};